import React from 'react'
import ReactDOM from 'react-dom/client'
import DegenCommandCenter from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DegenCommandCenter />
  </React.StrictMode>
)
